import { Colors } from "../constants/colors";
import { getRGBColorByHex } from "../services/colorsService";

export default {
  red: {
    backgroundColor: getRGBColorByHex(Colors.RED100, 0.2),
    color: Colors.RED300
  },
  green: {
    backgroundColor: getRGBColorByHex(Colors.GREEN500, 0.1),
    color: Colors.GREEN300
  },
  blue: {
    backgroundColor: getRGBColorByHex(Colors.BLUE500, 0.1),
    color: Colors.BLUE300
  },
  lightblue: {
    backgroundColor: getRGBColorByHex(Colors.BLUE100, 0.1),
    color: Colors.BLUE300
  },
  maroon: {
    backgroundColor: getRGBColorByHex(Colors.MAROON100, 0.2),
    color: Colors.MAROON200
  },
  orange: {
    backgroundColor: getRGBColorByHex(Colors.ORANGE100, 0.2),
    color: Colors.ORANGE300
  },
  purple: {
    backgroundColor: getRGBColorByHex(Colors.PURPLE100, 0.2),
    color: Colors.PURPLE200
  },
  grey: {
    backgroundColor: getRGBColorByHex(Colors.GREY300, 0.1),
    color: Colors.GREY300
  },
  teal: {
    backgroundColor: getRGBColorByHex(Colors.TEAL400, 0.1),
    color: Colors.TEAL300
  },
};
